import _ from 'lodash';
import moment from 'moment';
import BasicButton from 'components/Buttons/BasicButton';
import DiagnosisListPaginationListButton from 'assets/Icons/Arrow/ArrowLineRoundRight';
import ProcessCheckBar from 'components/Hospital/ProcessCheckBar';
import GenderMan from 'assets/Icons/Gender/GenderMan';
import GenderWoman from 'assets/Icons/Gender/GenderWoman';
import { useEffect, useState } from 'react';
import { ListWrapper, TableCell } from 'components/Hospital/PaginationForms';
import { diagnosisListWidth } from 'constants/pagination';
import { calculateAge } from 'utils/calculateAge';
import { changeMobileForm } from 'utils/changeMobileForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { pagePaths } from 'constants/path';
import { useLoginStore } from 'store/useLoginDataStore';
import { AccountLevel, DiagnosisStatus } from 'utils/statusCode';
import { Select } from 'antd';
import { Body5Regular } from 'styles/Global/typography';
import { BackgroundColor, BorderColor, TextColor } from 'styles/Global/colorSemantic';
import styled from 'styled-components';
import { AdminPaginationTableProps } from 'models/Admin/AdminPaginationTypes';
import { IDDiagnosis } from 'models/DCK/basicInterface';
import { getDiagnosisStatus } from 'pages/DCK/utils';

const MindUpAdminDiagnosisListPaginationTable = ({
    currentData,
    counselData,
    handleCounselData,
    handleCounsellerConfirmAlert: handleReservationAlert,
    handleCounselCompleteAlert,
    onChangeDiagnosisDateModal,
}: AdminPaginationTableProps) => {
    const { loginData } = useLoginStore();
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [visibleDiagnosis, setVisibleDiagnosis] = useState('');

    const isCounselorAccount = loginData.level === AccountLevel.externalCounselor;

    const handleMouseEnter = () => {
        setVisible(true);
    };

    const handleMouseLeave = () => {
        setVisible(false);
    };

    const handleSelectDropdownVisibleChange = (open: boolean, diagnosisId: string) => {
        setVisible(open);
        setVisibleDiagnosis(diagnosisId);
    };

    const reservationDateButton = (diagnosisId: string, reservationList: string[]) => {
        const parseOptionList = _.map(reservationList, (item, index) => {
            const parseDateTime = moment(item, 'YYYYMMDDHHmm').format('YYYY/MM/DD A hh:mm');
            return { value: item, label: parseDateTime };
        });

        const isCurrentSelected = counselData?.diagnosisId === diagnosisId;

        const currentValue = isCurrentSelected && counselData?.reservationDate ? counselData.reservationDate : '상담 일시 선택';

        const isDropdownVisible = visibleDiagnosis === diagnosisId && visible;
        const reservationDateColor = isCurrentSelected && !_.isEmpty(counselData.reservationDate);

        return _.isEmpty(reservationList) ? (
            <ReservationDateEmptyWrapper>요청한 상담 일시가 없습니다.</ReservationDateEmptyWrapper>
        ) : (
            <ReservationDateButtonSelectWrapper
                onClick={(e) => e.stopPropagation()}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                $visible={isDropdownVisible}
                $reservationDate={reservationDateColor}
            >
                <Select
                    value={currentValue} // defaultValue 대신 value 사용
                    suffixIcon={null}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                    dropdownStyle={{
                        position: 'absolute',
                        top: '40px',
                        border: `1px solid ${BorderColor.color_border_strong}`,
                        fontWeight: 500,
                        fontSize: '50px',
                    }}
                    style={{
                        fontSize: '30px', // 기본 텍스트 크기
                    }}
                    onChange={(e) => {
                        handleCounselData!({ diagnosisId: diagnosisId, reservationDate: e });
                    }}
                    open={visibleDiagnosis === diagnosisId && visible}
                    options={parseOptionList}
                    onDropdownVisibleChange={(open) => {
                        handleSelectDropdownVisibleChange(open, diagnosisId);
                    }}
                    onMouseEnter={(e) => {
                        setVisibleDiagnosis(diagnosisId);
                    }}
                    onMouseDown={(e) => {
                        setVisibleDiagnosis(diagnosisId);
                        setVisible(true);
                    }}
                />
            </ReservationDateButtonSelectWrapper>
        );
    };

    const selectButton = (item: IDDiagnosis) => {
        const isSelectedDiagnosis = counselData?.diagnosisId === item._id;

        return (
            <BasicButton
                onClick={(e: Event) => {
                    e.stopPropagation();
                    // if (_.isEmpty(selectedDate)) {
                    //     return;
                    // }
                    handleReservationAlert!(true);
                }}
                disabled={!isSelectedDiagnosis || _.isEmpty(counselData.reservationDate)}
                $height='100%'
                $type='fill'
                $fontSize='14px'
            >
                상담 확정
            </BasicButton>
        );
    };

    const isClickable = (item: IDDiagnosis): boolean => {
        const hasCounselDates = !_.isEmpty(item.counselDateTimeList) && item.status > DiagnosisStatus.completed;

        if (isCounselorAccount) {
            return hasCounselDates;
        }

        return true;
    };

    // ProgressCheckBar 조건 변경
    const processCheckBarClick = (item: IDDiagnosis) => {
        if (item.noShowDisabled && onChangeDiagnosisDateModal) {
            onChangeDiagnosisDateModal(item);
        } else {
            handleCounselData && handleCounselData({ diagnosisId: item._id, reservationDate: item.diagnosisDateTime });
            handleCounselCompleteAlert && handleCounselCompleteAlert();
        }
    };

    return (
        <>
            {currentData?.map((item, idx) => {
                const { birthDate } = calculateAge(item.patientIdentityNumber);
                return (
                    <ListWrapper key={idx} onClick={isClickable(item) ? () => navigate(pagePaths.viewDetaildiagnosis, { state: item }) : () => {}}>
                        <TableCell $width={diagnosisListWidth[0]} $type='name'>
                            {item.patientName + ' '}
                            {item.patientGender === 'male' ? <GenderMan /> : <GenderWoman />}
                        </TableCell>
                        <TableCell $width={diagnosisListWidth[1]}>{moment(birthDate, 'YYYYMMDD').format('YYYY/MM/DD')}</TableCell>
                        <TableCell $width={diagnosisListWidth[2]} $type='gradeName'>
                            {item.gradeName}
                        </TableCell>
                        <TableCell $width={diagnosisListWidth[3]}>{changeMobileForm(item.patientMobile)}</TableCell>
                        <TableCell $width={diagnosisListWidth[4]} $padding='10px 14px' diagnosisStatus={getDiagnosisStatus(item)}>
                            {item.status >= DiagnosisStatus.counselReserved && item.diagnosisDateTime
                                ? moment(item.diagnosisDateTime, 'YYYYMMDDHHmm').format('YYYY/MM/DD A hh:mm')
                                : reservationDateButton(item._id, item.counselDateTimeList)}
                        </TableCell>
                        <TableCell $width={diagnosisListWidth[5]} $padding='10px 14px'>
                            {item.status < DiagnosisStatus.counselReserved ? selectButton(item) : item.doctorName}
                        </TableCell>
                        <TableCell cellType='processBarCell' $width={diagnosisListWidth[6]}>
                            <ProcessCheckBar
                                diagnosisInfo={item}
                                $height='40px'
                                $top='44px'
                                onClick={() => {
                                    if (isCounselorAccount && (getDiagnosisStatus(item) === 'counselReserved' || getDiagnosisStatus(item) === 'reschedule')) {
                                        processCheckBarClick(item);
                                    }
                                }}
                            />
                        </TableCell>
                        <TableCell $width={diagnosisListWidth[7]}>{isClickable(item) && <DiagnosisListPaginationListButton />}</TableCell>
                    </ListWrapper>
                );
            })}
        </>
    );
};

export default MindUpAdminDiagnosisListPaginationTable;

const ReservationDateButtonSelectWrapper = styled.div<{ $visible: boolean; $reservationDate?: boolean }>`
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;

    .ant-select {
        width: 100%;
        height: 100%;
    }

    .ant-select-selector {
        height: 100% !important;
        display: flex;
        align-items: center;
        padding: 0 11px !important;
        color: ${TextColor.color_text_placeholder} !important;
        background-color: ${(props) => (props.$visible ? BackgroundColor.color_background_normal : 'inherit')} !important;
        border: ${(props) => props.$visible && `1px solid ${BorderColor.color_border_strong}`} !important;
    }

    .ant-select-selector:hover {
        border: 1px solid ${BorderColor.color_border_strong} !important;
        background-color: ${BackgroundColor.color_background_normal} !important;
        color: ${TextColor.color_text_placeholder} !important;
    }

    .ant-select-selector:hover .ant-select-selection-item {
        color: ${(props) => (props.$reservationDate ? TextColor.color_text_normal : TextColor.color_text_placeholder)} !important;
    }

    .ant-select-selection-item {
        font-weight: 500;
        color: ${(props) => (props.$reservationDate ? TextColor.color_text_normal : TextColor.color_text_placeholder)} !important;
    }

    .ant-select-dropdown {
        .ant-select-item {
            font-size: 14px;
            font-weight: 500;
            padding-left: 11px;
            padding-right: 11px;
        }
    }

    .ant-select-single.ant-select-show-arrow .ant-select-selection-item {
        font-size: 14px;
    }
`;

const ReservationDateEmptyWrapper = styled(Body5Regular)`
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    color: ${TextColor.color_text_weak};
`;
